import { css } from '@emotion/core';
import { parseToPixel } from "./utils";
import { font } from "./font";
export const {
  fontFamily,
  fontSize
} = font;
const fontNormal = css`
  font-style: normal;
`;
const fontWeightBold = css`
  font-weight: 700;
`;
const fontWeightRegular = css`
  font-weight: 500;
`;
const fontWeightNormal = css`
  font-weight: normal;
`;

const getFontSize = size => css`
  font-size: ${parseToPixel(size)};
  line-height: ${parseToPixel(size + 4)};
`;

const title1 = css`
  ${fontNormal};
  ${fontWeightBold};
  ${getFontSize(32)};
`;
const title2 = css`
  ${fontNormal};
  ${fontWeightBold};
  ${getFontSize(26)};
`;
const title3 = css`
  ${fontNormal};
  ${fontWeightBold};
  ${getFontSize(24)};
`;
const title4 = css`
  ${fontNormal};
  ${fontWeightBold};
  ${getFontSize(22)};
`;
const heading1 = css`
  ${fontNormal};
  ${fontWeightBold};
  ${getFontSize(20)};
`;
const heading2 = css`
  ${fontNormal};
  ${fontWeightBold};
  ${getFontSize(18)};
`;
const heading3 = css`
  ${fontNormal};
  ${fontWeightBold};
  font-size: 16px;
  line-height: 20px;
`;
const heading4 = css`
  ${fontNormal};
  ${fontWeightBold};
  ${getFontSize(14)};
`;
const heading5 = css`
  ${fontNormal};
  ${fontWeightBold};
  ${getFontSize(12)};
`;
const heading6 = css`
  ${fontNormal};
  ${fontWeightRegular}
  ${getFontSize(12)};
`;
const paragraph1 = css`
  ${fontNormal};
  ${fontWeightNormal};
  ${getFontSize(16)};
`;
const paragraph2 = css`
  ${fontNormal};
  ${fontWeightNormal};
  ${getFontSize(14)};
`;
const paragraph3 = css`
  ${fontNormal};
  ${fontWeightNormal};
  ${getFontSize(12)};
`;
const uppercase = css`
  textTransform: uppercase
`;
const label = css`
  font-size: 12px;
  ${fontWeightBold};
`;
const helperText = css`
  font-size: 12px;
  ${fontWeightNormal}
`;
export const typography = {
  title1,
  title2,
  title3,
  title4,
  heading1,
  heading2,
  heading3,
  heading4,
  heading5,
  heading6,
  paragraph1,
  paragraph2,
  paragraph3,
  uppercase,
  label,
  helperText
};